import { render, staticRenderFns } from "./PartnerMicrocart.vue?vue&type=template&id=2205854a&scoped=true&"
import script from "./PartnerMicrocart.vue?vue&type=script&async=true&lang=js&"
export * from "./PartnerMicrocart.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PartnerMicrocart.vue?vue&type=style&index=0&id=2205854a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205854a",
  null
  
)

export default component.exports